import React from 'react';
import { ReactComponent as AiStarsBlue } from 'src/assets/icons/new-ai-stars-blue.svg';
import { getDomainfromUrl } from 'src/utils/utilityMethods';

type Props = {
  label: string;
  message: string;
  sourceUrls: string[];
};

function AIFundingContainer({ label, message, sourceUrls = [] }: Props) {
  return (
    <div className="ai-funding-details-wrapper icp-fitmentment-tooltip-wrapper">
      <div className="icp-fitment-section">
        <div className="icp-fitment-static-heading">
          <p className="icp-fitment-heading">{label}</p>
          <div className="ai-badge-stars">
            <AiStarsBlue />
            <p>Sprouts AI</p>
          </div>
        </div>
      </div>
      <div className="icp-fitment-section">
        <div className="icp-fitement-heading">
          <div>
            <p>{message}</p>
          </div>

          {sourceUrls.length > 0 && (
            <>
              <p>Source Urls</p>
              <p className="icp-fitement-subheading">
                <ul>
                  {sourceUrls.map((url, i) => (
                    <li key={`signalSourceurl-${url}-${i}`}>
                      <a href={ensureScheme(url)} target="_blank" rel="noreferrer">
                        {getDomainfromUrl(ensureScheme(url)) || `Source Link ${i + 1}`}
                      </a>
                    </li>
                  ))}
                </ul>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(AIFundingContainer);

const ensureScheme = (url: string) => {
  if (!/^https?:\/\//i.test(url)) {
    return `http://${url}`;
  }
  return url;
};
